import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import { defaultTitle, localStorageVar, tokenKeyName } from "../../config";
import handleApiError from "../../helpers/handleApiError";
import {
  getProfileInformation,
  isReadOnly,
  updateProfile,
} from "../../services/accountService";
import {
  BsBoxSeam,
  BsBuilding,
  BsGear,
  BsJournalBookmarkFill,
  BsPencilSquare,
  BsPersonCircle,
} from "react-icons/bs";

// import { EditableInput } from "../Utility/EditableInput";
// import { initial, isEqual } from "lodash";
// import { EditableInputOldWIP } from "../Utility/EditableInputOldWIP";
// import { EditableInput } from "../Utility/EditableInput";
import axios from "axios";
import { apiUrl, constants } from "../../config";
// import { EditableEmail } from "./EditableEmail";
import { ClientAddressEdit } from "./ClientAddressEdit";
import { DiliTextCP } from "../Utility/DiliTextCP";
import {
  divisionAccesses,
  localStorageVariables,
  orderAndPositionTerminologyOptions,
  postOrderLabelPrintOptions,
} from "../../constants";
import { EmailEditModal } from "./EmailEditModal";
import { DisplayNameEditModal } from "./DisplayNameEditModal";
import PDFDownload from "../PDFDownload";
import { AccountManagement } from "./AccountManagement";
import jwtDecode from "jwt-decode";
import { SubscriptionManagement } from "./SubscriptionManagement";

import AccordionCard from "../AccordionCard";
import LandingPageSelector from "./LandingPageSelector";
import Checkbox from "../Checkbox";
import { RestrictedContent } from "../Navbar/RestrictedContent";

const PDFs = {
  codOptin: "CoD_Opt_In_Form.pdf",
  natOpContactList: "National Operations Contact List.pdf",
  NDLIFreightClaimsProcedures: "NDLI Freight Claims Procedures 011215.pdf",
  networkTermsAndConditions: "Network Terms and Conditions.pdf",
  returns: "Returns.pdf",
};

//Start Client Profile Component
export const NewClientProfile2 = ({
  setLoading,
  linkedAccounts,
  setLinkedAccounts,
}) => {
  const history = useHistory();

  const [decodedJWT, setDecodedJWT] = useState(() => {
    return jwtDecode(localStorage.getItem(tokenKeyName));
  });

  const [initialClientProfile, setInitialClientProfile] = useState({
    userId: "",
    userName: "",
    userEmailAddresses: "",
    clientId: "",
    clientName: "",
    shippingAddress: "",
    shippingSuite: "",
    shippingCity: "",
    shippingState: "",
    shippingZip: "",
    clientEmailAddresses: "",
    billingType: "",
    codFee: "",
    paymentTerms: "",
    billingCycle: "",
    minimumValuationAmount: "",
    maximumValuationAmount: "",
    valuationRate: "",
    dropShipInfos: [],
    optInEmail: false,
    optInReturnEmail: false,
    optInBuyoutEmail: false,
    allowDuplicateInvoice: false,
    isMainAccount: false,
  });
  const [currentClientProfile, setCurrentClientProfile] = useState({
    userId: "",
    userName: "",
    userEmailAddresses: "",
    clientId: "",
    clientName: "",
    shippingAddress: "",
    shippingSuite: "",
    shippingCity: "",
    shippingState: "",
    shippingZip: "",
    clientEmailAddresses: "",
    billingType: "",
    codFee: "",
    paymentTerms: "",
    billingCycle: "",
    minimumValuationAmount: "",
    maximumValuationAmount: "",
    valuationRate: "",
    dropShipInfos: [],
    optInEmail: false,
    optInReturnEmail: false,
    optInBuyoutEmail: false,
    allowDuplicateInvoice: false,
    isMainAccount: false,
  });
  // console.log(currentClientProfile);
  //local settings
  const [initialLocalSettings, setInitialLocalSettings] = useState({
    [localStorageVariables.postOrderLabelPrintMethod]:
      localStorage.getItem(localStorageVariables.postOrderLabelPrintMethod) ??
      postOrderLabelPrintOptions[0].value,
    [localStorageVariables.orderTerminology]:
      localStorage.getItem(localStorageVariables.orderTerminology) ??
      orderAndPositionTerminologyOptions.orderTerminology.order,
    [localStorageVariables.positionTerminology]:
      localStorage.getItem(localStorageVariables.positionTerminology) ??
      orderAndPositionTerminologyOptions.positionTerminology.position,
  });
  // console.log("initial", initialLocalSettings);
  const [currentLocalSettings, setCurrentLocalSettings] = useState({
    [localStorageVariables.postOrderLabelPrintMethod]:
      localStorage.getItem(localStorageVariables.postOrderLabelPrintMethod) ??
      postOrderLabelPrintOptions[0].value,
    [localStorageVariables.orderTerminology]:
      localStorage.getItem(localStorageVariables.orderTerminology) ??
      orderAndPositionTerminologyOptions.orderTerminology.order,
    [localStorageVariables.positionTerminology]:
      localStorage.getItem(localStorageVariables.positionTerminology) ??
      orderAndPositionTerminologyOptions.positionTerminology.position,
  });
  // console.log("current", currentLocalSettings);

  const [isLandingPageSelectorModified, setIsLandingPageSelectorModified] =
    useState(false);

  const landingPageSelectorEventRef = useRef(null);

  const handleChangeLocalSettings = (e) => {
    setCurrentLocalSettings({
      ...currentLocalSettings,
      [e.target.name]: e.target.value,
    });
  };

  const handleSaveLocalSettings = () => {
    //save all settings into local storage, could potentially check to see if they have changed first, not sure which would be better/more optimized if it matters
    for (const key in currentLocalSettings) {
      localStorage.setItem(key, currentLocalSettings[key]);
    }
    setInitialLocalSettings({ ...currentLocalSettings });
  };
  const handleResetLocalSettings = () => {
    setCurrentLocalSettings(initialLocalSettings);
  };

  const handleSaveAccountSettings = async (e) => {
    //save local settings
    handleSaveLocalSettings();
    // save landing page selector
    landingPageSelectorEventRef.current?.saveLandingPageOptions();

    //save button won't show up in the first place if the account settings aren't different from the original but just in case
    if (!accountSettingsDifferFromOriginal) return;
    const profileInfoToUpdate = {
      ...initialClientProfile,
      optInEmail: currentClientProfile.optInEmail,
      optInReturnEmail: currentClientProfile.optInReturnEmail,
      optInBuyoutEmail: currentClientProfile.optInBuyoutEmail,
      allowDuplicateInvoice: currentClientProfile.allowDuplicateInvoice,
      isMainAccount: currentClientProfile.isMainAccount,
    };
    try {
      setLoading(true);
      await updateProfile(profileInfoToUpdate);
      const reRetrieveAccountSettingsResponse = await getProfileInformation();

      setInitialClientProfile({
        ...initialClientProfile,
        optInEmail: reRetrieveAccountSettingsResponse.data.optInEmail,
        optInReturnEmail:
          reRetrieveAccountSettingsResponse.data.optInReturnEmail,
        optInBuyoutEmail:
          reRetrieveAccountSettingsResponse.data.optInBuyoutEmail,
        allowDuplicateInvoice:
          reRetrieveAccountSettingsResponse.data.allowDuplicateInvoice,
        isMainAccount: reRetrieveAccountSettingsResponse.data.isMainAccount,
      });
      setCurrentClientProfile({
        ...currentClientProfile,
        optInEmail: reRetrieveAccountSettingsResponse.data.optInEmail,
        optInReturnEmail:
          reRetrieveAccountSettingsResponse.data.optInReturnEmail,
        optInBuyoutEmail:
          reRetrieveAccountSettingsResponse.data.optInBuyoutEmail,
        allowDuplicateInvoice:
          reRetrieveAccountSettingsResponse.data.allowDuplicateInvoice,
        isMainAccount: reRetrieveAccountSettingsResponse.data.isMainAccount,
      });
    } catch (ex) {
      handleApiError(ex);
    } finally {
      setLoading(false);
    }
  };

  const handleResetAccountSettings = () => {
    landingPageSelectorEventRef.current?.resetLandingPageOptions();

    handleResetLocalSettings();
    setCurrentClientProfile((prevCurrentClientProfile) => {
      return {
        ...prevCurrentClientProfile,
        optInEmail: initialClientProfile.optInEmail,
        optInReturnEmail: initialClientProfile.optInReturnEmail,
        optInBuyoutEmail: initialClientProfile.optInBuyoutEmail,
        allowDuplicateInvoice: initialClientProfile.allowDuplicateInvoice,
        isMainAccount: initialClientProfile.isMainAccount,
      };
    });
  };

  const [userEmailsValid, setUserEmailsValid] = useState(true);
  const [clientEmailsValid, setClientEmailsValid] = useState(true);
  const [resetUserInfoCount, setResetUserInfoCount] = useState(0); //used as notification in editable email input component for user info emails
  const [resetClientInfoCount, setResetClientInfoCount] = useState(0); //used as notification in editable email input component for client info emails

  // const [defaultCodSetting, setDefaultCodSetting] = useState(
  //   localStorage.getItem("client-portal-defaultCodOption") ??
  //     codOptions.None.value
  // );
  // const handleChangeDefaultCodOption = (e) => {
  //   localStorage.setItem("client-portal-defaultCodOption", e.target.value);
  //   setDefaultCodSetting(e.target.value);
  // };
  const [isAddressEditModalOpen, setIsAddressEditModalOpen] = useState(false);
  const handleOpenAddressEditModal = () => {
    setIsAddressEditModalOpen(true);
  };
  const handleCloseAddressEditModal = () => {
    // console.log("close");
    setIsAddressEditModalOpen(false);
  };

  const editAddress = (editedValues) => {
    setCurrentClientProfile((prevCurrentClientProfile) => {
      return {
        ...prevCurrentClientProfile,
        shippingAddress: editedValues.address,
        shippingSuite: editedValues.suite,
        shippingCity: editedValues.city,
        shippingState: editedValues.state,
        shippingZip: editedValues.zip,
      };
    });
  };
  const finishEditingAddress = (editedValues) => {
    setCurrentClientProfile((prevCurrentClientProfile) => {
      return {
        ...prevCurrentClientProfile,
        shippingAddress: editedValues.address,
        shippingSuite: editedValues.suite,
        shippingCity: editedValues.city,
        shippingState: editedValues.state,
        shippingZip: editedValues.zip,
      };
    });
    setIsAddressEditModalOpen(false);
  };

  const [isUserEmailsEditModalOpen, setIsUserEmailsEditModalOpen] =
    useState(false);
  const handleOpenUserEmailsEditModal = () => {
    setIsUserEmailsEditModalOpen(true);
  };
  const handleCloseUserEmailsEditModal = () => {
    setIsUserEmailsEditModalOpen(false);
  };
  const finishEditingUserEmails = (editedEmailString) => {
    setCurrentClientProfile((prevCurrentClientProfile) => {
      return {
        ...prevCurrentClientProfile,
        userEmailAddresses: editedEmailString,
      };
    });
  };

  const [isUserDisplayNameEditModalOpen, setIsDisplayNameEditModelOpen] =
    useState(false);
  const handleOpenUserDisplayNameEditModal = () => {
    setIsDisplayNameEditModelOpen(true);
  };
  const handleCloseUserDisplayNameEditModal = () => {
    setIsDisplayNameEditModelOpen(false);
  };
  const finishEditingUserDisplayName = (editedUserDisplayName) => {
    setCurrentClientProfile((prevCurrentClientProfile) => {
      return {
        ...prevCurrentClientProfile,
        userName: editedUserDisplayName,
      };
    });
  };

  const [isClientEmailsEditModalOpen, setIsClientEmailsEditModalOpen] =
    useState(false);
  const handleOpenClientEmailsEditModal = () => {
    setIsClientEmailsEditModalOpen(true);
  };
  const handleCloseClientEmailsEditModal = () => {
    setIsClientEmailsEditModalOpen(false);
  };
  const finishEditingClientEmails = (editedEmailString) => {
    setCurrentClientProfile((prevCurrentClientProfile) => {
      return {
        ...prevCurrentClientProfile,
        clientEmailAddresses: editedEmailString,
      };
    });
  };

  const [selectedProcedureToDownload, setSelectedProcedureToDownload] =
    useState("");
  // console.log("parent");
  // console.log(userEmailsValid);
  // console.log("parent");
  // console.log(clientEmailsValid);

  const handleEditClientProfile = (e) => {
    // console.log("handle edit client profile");
    // console.log(e);
    // console.log(e.target.value);
    // console.log(e.target.value);
    // console.log(e.target.checked);
    setCurrentClientProfile({
      ...currentClientProfile,
      [e.target.name]: e.target.checked ?? e.target.value,
    });
    // console.log(e.target.name);
  };

  const handleChangeUserEmails = (newEmailString) => {
    setCurrentClientProfile({
      ...currentClientProfile,
      userEmailAddresses: newEmailString,
    });
  };
  const handleChangeClientEmails = (newEmailString) => {
    setCurrentClientProfile({
      ...currentClientProfile,
      clientEmailAddresses: newEmailString,
    });
  };

  const onSelectProcedureToDownload = (e) => {
    setSelectedProcedureToDownload(e.target.value);
  };

  const handlePrintProcedureClick = () => {
    if (!selectedProcedureToDownload) return;

    window.open(
      "pdfs/" + selectedProcedureToDownload,
      "_blank",
      "noreferrer noopener"
    );
  };

  // const inputStates = {
  //   display: "display",
  //   editting: "editting",
  // };
  // const [profileViewInputState, setProfileViewInputState] = useState({
  //   userId: inputStates.display,
  //   userName: inputStates.display,
  //   // userEmailAddresses: inputStates.display,
  //   clientId: inputStates.display,
  //   clientName: inputStates.display,
  //   shippingAddress: inputStates.display,
  //   shippingSuite: inputStates.display,
  //   shippingCity: inputStates.display,
  //   shippingState: inputStates.display,
  //   shippingZip: inputStates.display,
  //   // clientEmailAddresses: inputStates.display,
  //   BillingType: inputStates.display,
  //   CODFee: inputStates.display,
  //   PaymentTerms: inputStates.display,
  //   BillingCycle: inputStates.display,
  //   MinimumValuationAmount: inputStates.display,
  //   MaximumValuationAmount: inputStates.display,
  //   ValuationRate: inputStates.display,
  // });
  // const startEditting = (e) => {
  //   // setProfileViewInputState({
  //   //   ...profileViewInputState,
  //   //   [e.target.name]: inputStates.editting,
  //   // });
  // };

  // const [valuesDifferFromOriginal, setValuesDifferFromOriginal] =
  //   useState(false);

  // //if we click out of an input and the values of their information are different than the original, set values differ to true
  // //otherwise change it back to false
  // const handleClickOutOfEditting = (e) => {
  // setProfileViewInputState({
  //   ...profileViewInputState,
  //   [e.target.name]: inputStates.display,
  // });
  // if (!isEqual(currentClientProfile, initialClientProfile)) {
  //   setValuesDifferFromOriginal(true);
  // } else {
  //   setValuesDifferFromOriginal(false);
  // }
  // };
  // console.log(currentClientProfile.clientEmailAddresses);

  // const valuesDifferFromOriginal = !isEqual(
  //   currentClientProfile,
  //   initialClientProfile
  // );
  const userInfoValuesDifferFromOriginal =
    currentClientProfile.userEmailAddresses !==
      initialClientProfile.userEmailAddresses ||
    currentClientProfile.userName !== initialClientProfile.userName;
  //   || //moved to account settings
  // currentClientProfile.optInEmail !== initialClientProfile.optInEmail;

  //combining with everything else in account settings
  // const localSettingsDifferFromOriginal =
  //   currentLocalSettings.postOrderLabelPrintMethod !==
  //   initialLocalSettings.postOrderLabelPrintMethod;

  const accountSettingsDifferFromOriginal =
    currentLocalSettings.postOrderLabelPrintMethod !==
      initialLocalSettings.postOrderLabelPrintMethod ||
    currentLocalSettings.orderTerminology !==
      initialLocalSettings.orderTerminology ||
    currentLocalSettings.positionTerminology !==
      initialLocalSettings.positionTerminology ||
    currentClientProfile.optInEmail !== initialClientProfile.optInEmail ||
    currentClientProfile.optInReturnEmail !==
      initialClientProfile.optInReturnEmail ||
    currentClientProfile.optInBuyoutEmail !==
      initialClientProfile.optInBuyoutEmail ||
    currentClientProfile.allowDuplicateInvoice !==
      initialClientProfile.allowDuplicateInvoice;

  //reset top section
  const resetUserInfoSection = () => {
    //reset local settings
    // handleResetLocalSettings();
    //update state notification thing to send to user email editable input
    setResetUserInfoCount(
      (prevResetUserInfoCount) => prevResetUserInfoCount + 1
    );
    // console.log("Reset user info");
    //only want to reset top section
    setCurrentClientProfile((prevCurrentClientProfile) => {
      return {
        ...prevCurrentClientProfile,
        userEmailAddresses: initialClientProfile.userEmailAddresses,
        optInEmail: initialClientProfile.optInEmail,
      };
    });
  };

  const clientInfoValuesDifferFromOriginal =
    currentClientProfile.shippingAddress !==
      initialClientProfile.shippingAddress ||
    currentClientProfile.shippingSuite !== initialClientProfile.shippingSuite ||
    currentClientProfile.shippingCity !== initialClientProfile.shippingCity ||
    currentClientProfile.shippingState !== initialClientProfile.shippingState ||
    currentClientProfile.shippingZip !== initialClientProfile.shippingZip ||
    currentClientProfile.clientEmailAddresses !==
      initialClientProfile.clientEmailAddresses;
  const resetClientInfo = () => {
    setResetClientInfoCount(
      (prevResetClientInfoCount) => prevResetClientInfoCount + 1
    );
    setCurrentClientProfile((prevCurrentClientProfile) => {
      return {
        ...prevCurrentClientProfile,
        shippingAddress: initialClientProfile.shippingAddress,
        shippingSuite: initialClientProfile.shippingSuite,
        shippingCity: initialClientProfile.shippingCity,
        shippingState: initialClientProfile.shippingState,
        shippingZip: initialClientProfile.shippingZip,
        clientEmailAddresses: initialClientProfile.clientEmailAddresses,
      };
    });
    // console.log("reset client info");
  };

  useEffect(() => {
    (async () => {
      setLoading(true);

      try {
        const { data: foundClientProfile } = await getProfileInformation();
        // console.log(foundClientProfile);

        setInitialClientProfile({
          ...foundClientProfile,
          clientEmailAddresses: foundClientProfile.clientEmailAddresses.trim(),
          shippingAddress: foundClientProfile.shippingAddress.trim(),
          // userEmailAddresses: foundClientProfile.userEmailAddresses.split(";"),
          // clientEmailAddresses:
          //   foundClientProfile.clientEmailAddresses.split(";"),
        });
        setCurrentClientProfile({
          ...foundClientProfile,
          clientEmailAddresses: foundClientProfile.clientEmailAddresses.trim(),
          shippingAddress: foundClientProfile.shippingAddress.trim(),
          // userEmailAddresses: foundClientProfile.userEmailAddresses.split(";"),
          // clientEmailAddresses:
          //   foundClientProfile.clientEmailAddresses.split(";"),
        });

        setLoading(false);
      } catch (ex) {
        setLoading(false);
        handleApiError(ex, history);
      }
    })();
  }, [history, setLoading]);

  // console.log("printing useremailaddresses");
  // console.log(initialClientProfile.userEmailAddresses);
  // console.log(currentClientProfile.userEmailAddresses);
  const saveUserInfoChanges = async (e) => {
    // if (!userEmailsValid) return;
    // console.log("saving changes");
    // console.log(currentClientProfile.userEmailAddresses);
    if (userInfoValuesDifferFromOriginal) {
      const profileInfoToUpdate = {
        ...initialClientProfile,
        userEmailAddresses: currentClientProfile.userEmailAddresses,
        userName: currentClientProfile.userName,
        // optInEmail: currentClientProfile.optInEmail,
      };
      try {
        setLoading(true);
        if (currentClientProfile.userName !== initialClientProfile.userName) {
          localStorage.setItem(
            localStorageVar.displayNameKey,
            currentClientProfile.userName
          );
        }
        const saveUserInfoResponse = await axios.put(
          `${apiUrl}/Account/UpdateProfile`,
          profileInfoToUpdate
        );
        // console.log(saveUserInfoResponse);
        const reRetrieveUserProfileInformationResponse =
          await getProfileInformation();
        // console.log(reRetrieveUserProfileInformationResponse);
        //change the initial client profile info to data from the backend because that is
        //what we should be comparing to.
        //i set just this stuff specifically as we had different sections that saved separately, and you could work on multiple sections before saving each.
        //you can still work on the account settings and then change email without saving account settings, so this is still needed.
        setInitialClientProfile({
          ...initialClientProfile,
          userEmailAddresses:
            reRetrieveUserProfileInformationResponse.data.userEmailAddresses,
          userName: reRetrieveUserProfileInformationResponse.data.userName,
          // optInEmail: reRetrieveUserProfileInformationResponse.data.optInEmail,
        });
        setCurrentClientProfile({
          ...currentClientProfile,
          userEmailAddresses:
            reRetrieveUserProfileInformationResponse.data.userEmailAddresses,
          userName: reRetrieveUserProfileInformationResponse.data.userName,
          // optInEmail: reRetrieveUserProfileInformationResponse.data.optInEmail,
        });

        setLoading(false);
        return true;
      } catch (ex) {
        setLoading(false);
        // console.log(ex);
        handleApiError(ex, history);
        return false;
      }
    }
  };

  // console.log(initialClientProfile);
  // console.log(currentClientProfile);
  const saveClientInfoChanges = async (e) => {
    // if (!userEmailsValid) return;
    // console.log("saving client info changes");
    const profileInfoToUpdate = {
      ...initialClientProfile,
      clientEmailAddresses: currentClientProfile.clientEmailAddresses,
      shippingAddress: currentClientProfile.shippingAddress,
      shippingSuite: currentClientProfile.shippingSuite,
      shippingCity: currentClientProfile.shippingCity,
      shippingState: currentClientProfile.shippingState,
      shippingZip: currentClientProfile.shippingZip,
    };
    try {
      setLoading(true);
      const saveUserInfoResponse = await axios.put(
        `${apiUrl}/Account/UpdateProfile`,
        profileInfoToUpdate
      );
      // console.log(saveUserInfoResponse);
      const reRetrieveUserProfileInformationResponse =
        await getProfileInformation();
      // console.log(reRetrieveUserProfileInformationResponse);
      //change the initial client profile info to data from the backend because that is
      //what we should be comparing to.
      setInitialClientProfile({
        ...initialClientProfile,
        clientEmailAddresses:
          reRetrieveUserProfileInformationResponse.data.clientEmailAddresses,
        shippingAddress:
          reRetrieveUserProfileInformationResponse.data.shippingAddress,
        shippingSuite:
          reRetrieveUserProfileInformationResponse.data.shippingSuite,
        shippingCity:
          reRetrieveUserProfileInformationResponse.data.shippingCity,
        shippingState:
          reRetrieveUserProfileInformationResponse.data.shippingState,
        shippingZip: reRetrieveUserProfileInformationResponse.data.shippingZip,
      });
      setCurrentClientProfile({
        ...currentClientProfile,
        clientEmailAddresses:
          reRetrieveUserProfileInformationResponse.data.clientEmailAddresses,
        shippingAddress:
          reRetrieveUserProfileInformationResponse.data.shippingAddress,
        shippingSuite:
          reRetrieveUserProfileInformationResponse.data.shippingSuite,
        shippingCity:
          reRetrieveUserProfileInformationResponse.data.shippingCity,
        shippingState:
          reRetrieveUserProfileInformationResponse.data.shippingState,
        shippingZip: reRetrieveUserProfileInformationResponse.data.shippingZip,
      });
      setLoading(false);
    } catch (ex) {
      setLoading(false);
      // console.log(ex);
      handleApiError(ex, history);
    }
  };

  //client cannot change billing info
  // const saveBillingInfoChanges = (e) => {};

  const handleEditDisplayName = (e) => {
    // console.log(e.target.value);
    setCurrentClientProfile((prevCurrentClientProfile) => {
      return {
        ...prevCurrentClientProfile,
        userName: e.target.value,
      };
    });
  };
  const cancelEditDisplayName = () => {
    setCurrentClientProfile((prevCurrentClientProfile) => {
      return {
        ...prevCurrentClientProfile,
        userName: initialClientProfile.userName,
      };
    });
  };
  return (
    <>
      <Helmet>
        <title>View Profile - {defaultTitle}</title>
      </Helmet>
      <DisplayNameEditModal
        show={isUserDisplayNameEditModalOpen}
        onHide={handleCloseUserDisplayNameEditModal}
        // finishEditDisplayName={finishEditingUserDisplayName}
        saveChanges={saveUserInfoChanges}
        initialDisplayName={initialClientProfile.userName}
        currentDisplayName={currentClientProfile.userName}
        handleEditDisplayName={handleEditDisplayName}
        cancelEditDisplayName={cancelEditDisplayName}
        history={history}
      />

      <EmailEditModal
        show={isUserEmailsEditModalOpen}
        onHide={handleCloseUserEmailsEditModal}
        title="Editing User Email Addresses"
        emailString={currentClientProfile.userEmailAddresses}
        finishEditingUserEmails={finishEditingUserEmails}
        returnNewEmailString={handleChangeUserEmails}
        maxEmails={5}
        maxEmailLength={500 / 5 - 2}
        setEmailsValid={setUserEmailsValid}
        saveChanges={saveUserInfoChanges}
        initialEmailString={initialClientProfile.userEmailAddresses}
      />

      <EmailEditModal
        show={isClientEmailsEditModalOpen}
        onHide={handleCloseClientEmailsEditModal}
        title="Editing Client Email Addresses"
        emailString={currentClientProfile.clientEmailAddresses}
        finishEditingUserEmails={finishEditingClientEmails}
        returnNewEmailString={handleChangeClientEmails}
        maxEmails={5}
        maxEmailLength={500 / 5 - 2}
        setEmailsValid={setClientEmailsValid}
        saveChanges={saveClientInfoChanges}
        initialEmailString={initialClientProfile.clientEmailAddresses}
      />

      <ClientAddressEdit
        show={isAddressEditModalOpen}
        onHide={handleCloseAddressEditModal}
        address={currentClientProfile.shippingAddress}
        suite={currentClientProfile.shippingSuite}
        city={currentClientProfile.shippingCity}
        state={currentClientProfile.shippingState}
        zip={currentClientProfile.shippingZip}
        finishEditingAddress={finishEditingAddress}
        editAddress={editAddress}
        saveChanges={saveClientInfoChanges}
        initialAddress={{
          address: initialClientProfile.shippingAddress,
          suite: initialClientProfile.shippingSuite,
          city: initialClientProfile.shippingCity,
          state: initialClientProfile.shippingState,
          zip: initialClientProfile.shippingZip,
        }}
      />
      <div className="container form-container px-0 py-0">
        <AccordionCard
          eventKey="userInformation"
          title="User Information"
          icon={BsPersonCircle}
        >
          <div className="row">
            <div className="col-md-6">
              <div className="col-12 client-profile-info-display-header">
                User ID
              </div>
              <div className="col-12">
                {/* <EditableInput
                        name="userId"
                        value={currentClientProfile.userId}
                        onChange={handleEditClientProfile}
                        // onBlur={handleClickOutOfEditting}
                        maxLength="500"
                      /> */}
                {currentClientProfile.userId}
              </div>
              <div className="col-12 client-profile-info-display-header">
                Display Name
                {!isReadOnly(decodedJWT) && (
                  <button
                    type="button"
                    className="btn p-0 shadow-none"
                    onClick={handleOpenUserDisplayNameEditModal}
                  >
                    <BsPencilSquare
                      className="mx-1 text-note"
                      style={{ marginTop: "-7px" }}
                    />
                  </button>
                )}
              </div>
              <div className="col-12">
                {/* <EditableInput
                        name="userName"
                        value={currentClientProfile.userName}
                        onChange={handleEditClientProfile}
                        // onBlur={handleClickOutOfEditting}
                        maxLength="500"
                      /> */}
                {currentClientProfile.userName}

                {/* <input
                        type="text"
                        className={
                          "form-control editable-input py-1" +
                          (profileViewInputState.userName ===
                          inputStates.display
                            ? " border-0 px-0"
                            : "")
                        }
                        value={currentClientProfile.userName ?? ""}
                        name="userName"
                        style={{ width: "fit-content" }}
                        onChange={handleEditClientProfile}
                        onFocus={startEditting}
                        onBlur={handleClickOutOfEditting}
                      /> */}
              </div>
            </div>
            <div className="col-md-6">
              <div className="col-12 client-profile-info-display-header">
                Your Email Addresses
                {!isReadOnly(decodedJWT) && (
                  <button
                    type="button"
                    className="btn p-0 shadow-none"
                    onClick={handleOpenUserEmailsEditModal}
                  >
                    <BsPencilSquare
                      className="mx-1 text-note"
                      style={{ marginTop: "-7px" }}
                    />
                  </button>
                )}
              </div>

              <div className="col-md-7">
                <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                  {currentClientProfile?.userEmailAddresses
                    ?.split(";")
                    ?.map((email, index) => {
                      return <li key={index + "-" + email}>{email.trim()}</li>;
                    })}
                </ul>

                {/* <EditableEmail
                        emailString={currentClientProfile.userEmailAddresses}
                        initialEmailString={
                          initialClientProfile.userEmailAddresses
                        }
                        returnNewEmailString={handleChangeUserEmails}
                        maxEmails={5}
                        maxEmailLength={500 / 5 - 2}
                        setEmailsValid={setUserEmailsValid}
                        resetStateNotif={resetUserInfoCount}
                      /> */}
              </div>
              {/* {currentClientProfile.userEmailAddresses.map(
                      (emailAddress) => {
                        return (
                          <input
                            type="text"
                            className={
                              "form-control editable-input py-1" +
                              (profileViewInputState.userEmailAddresses ===
                              inputStates.display
                                ? " border-0 px-0"
                                : "")
                            }
                            value={emailAddress ?? ""}
                            name="userName"
                            style={{ width: "fit-content" }}
                            onChange={handleEditClientProfile}
                            onFocus={startEditting}
                            onBlur={handleClickOutOfEditting}
                          />
                        );
                      }
                    )} */}
            </div>
          </div>

          {/* <div className="px-3 pt-2">
                  <h5>User Settings</h5>
                </div>
                <DiliTextCP
                  label="Default Cod Setting"
                  name="defaultCodSetting"
                  value={defaultCodSetting}
                  type="select"
                  className="form-group col-md-4"
                  onChange={handleChangeDefaultCodOption}
                >
                  <option value={codOptions.None.value}>
                    {codOptions.None.display}
                  </option>
                  <option value={codOptions.COD.value}>
                    {codOptions.COD.display}
                  </option>
                  <option value={codOptions.CertifiedFunds.value}>
                    {codOptions.CertifiedFunds.display}
                  </option>
                </DiliTextCP> */}
        </AccordionCard>

        <RestrictedContent allowedDivisionAccesses={[divisionAccesses.network]}>
          <AccountManagement
            setLoading={setLoading}
            linkedAccounts={linkedAccounts}
            setLinkedAccounts={setLinkedAccounts}
            decodedToken={decodedJWT}
          />
        </RestrictedContent>
        <SubscriptionManagement history={history} />
        <AccordionCard
          eventKey="accountSettings"
          title="Account Settings"
          icon={BsGear}
          headerChildren={
            (accountSettingsDifferFromOriginal ||
              isLandingPageSelectorModified) && (
              <div className="row">
                <button
                  className="btn btn-secondary mx-3 mx-md-1 mt-2 my-md-0 ml-md-auto btn-swap"
                  onClick={handleResetAccountSettings}
                >
                  Reset
                </button>
                <button
                  className="btn btn-secondary mx-3 mx-md-1 my-1 my-md-0 btn-swap"
                  onClick={handleSaveAccountSettings}
                >
                  Save
                </button>
              </div>
            )
          }
        >
          <div className="row">
            <RestrictedContent
              allowedDivisionAccesses={[divisionAccesses.network]}
            >
              <div className="col-md-6 pl-8">
                <h6 className="font-semibold my-0">Email Notifications</h6>
                <div className="px-2">
                  <Checkbox
                    label="Order confirmation emails"
                    name="optInEmail"
                    checked={currentClientProfile.optInEmail}
                    onChange={handleEditClientProfile}
                  />
                  <Checkbox
                    label="Return confirmation emails"
                    name="optInReturnEmail"
                    checked={currentClientProfile.optInReturnEmail}
                    onChange={handleEditClientProfile}
                  />
                  <Checkbox
                    label="Buyout confirmation emails"
                    name="optInBuyoutEmail"
                    checked={currentClientProfile.optInBuyoutEmail}
                    onChange={handleEditClientProfile}
                  />
                </div>

                <h6 className="font-semibold my-0">Order Preferences</h6>
                <div className="px-2">
                  <Checkbox
                    label="Allow duplicate invoices across orders"
                    name="allowDuplicateInvoice"
                    checked={currentClientProfile.allowDuplicateInvoice}
                    onChange={handleEditClientProfile}
                  />
                </div>
              </div>
            </RestrictedContent>

            <div className="col-md-6 pl-8 pl-lg-0">
              <RestrictedContent
                allowedDivisionAccesses={[divisionAccesses.network]}
              >
                <div className="form-group d-flex flex-column flex-xl-row">
                  <label
                    className="text-nowrap mr-xl-2 mb-0"
                    htmlFor="order-labels-setting"
                  >
                    After placing an order:
                  </label>
                  <select
                    className="form-control form-control-sm"
                    id="order-labels-setting"
                    name="postOrderLabelPrintMethod"
                    value={currentLocalSettings.postOrderLabelPrintMethod}
                    onChange={handleChangeLocalSettings}
                  >
                    {postOrderLabelPrintOptions.map((method) => (
                      <option key={method.value} value={method.value}>
                        {method.label}
                      </option>
                    ))}
                  </select>
                </div>

                <LandingPageSelector
                  ref={landingPageSelectorEventRef}
                  isLandingOptionsModified={(isDifferent) => {
                    setIsLandingPageSelectorModified(isDifferent);
                  }}
                />
              </RestrictedContent>
              <RestrictedContent
                allowedDivisionAccesses={[divisionAccesses.dedicated]}
              >
                <div className="form-group d-flex flex-column flex-xl-row">
                  <label
                    className="text-nowrap mr-xl-2 mb-0"
                    htmlFor="order-labels-setting"
                  >
                    Order Terminology
                  </label>
                  <select
                    className="form-control form-control-sm"
                    id="order-terminology"
                    name="orderTerminology"
                    value={currentLocalSettings.orderTerminology}
                    onChange={handleChangeLocalSettings}
                  >
                    {Object.values(
                      orderAndPositionTerminologyOptions.orderTerminology
                    ).map((terminology) => (
                      <option key={terminology} value={terminology}>
                        {terminology}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group d-flex flex-column flex-xl-row">
                  <label
                    className="text-nowrap mr-xl-2 mb-0"
                    htmlFor="order-labels-setting"
                  >
                    Position Terminology
                  </label>
                  <select
                    className="form-control form-control-sm"
                    id="position-terminology"
                    name="positionTerminology"
                    value={currentLocalSettings.positionTerminology}
                    onChange={handleChangeLocalSettings}
                  >
                    {Object.values(
                      orderAndPositionTerminologyOptions.positionTerminology
                    ).map((terminology) => (
                      <option key={terminology} value={terminology}>
                        {terminology}
                      </option>
                    ))}
                  </select>
                </div>
              </RestrictedContent>
            </div>
          </div>
        </AccordionCard>
        <AccordionCard
          eventKey="clientInformation"
          title="Client Information"
          icon={BsBuilding}
        >
          <div className="row">
            <div className="col-md-6">
              <div className="col-12 client-profile-info-display-header">
                Name
              </div>
              <div className="col-12 pb-1">
                {currentClientProfile.clientName}
              </div>
              <div className="col-12 client-profile-info-display-header">
                Client ID
              </div>
              <div className="col-12 pb-1">{currentClientProfile.clientId}</div>
              <div className="col-12 client-profile-info-display-header">
                Address
                {!isReadOnly(decodedJWT) && (
                  <button
                    type="button"
                    className="btn p-0 shadow-none"
                    onClick={handleOpenAddressEditModal}
                  >
                    <BsPencilSquare
                      className="mx-1 text-note"
                      style={{ marginTop: "-7px" }}
                    />
                  </button>
                )}
              </div>
              <address style={{ paddingLeft: "15px", paddingRight: "15px" }}>
                {currentClientProfile.shippingAddress +
                  (currentClientProfile.shippingSuite
                    ? " - Suite: " + currentClientProfile.shippingSuite
                    : "")}
                <br />
                {currentClientProfile.shippingCity &&
                  currentClientProfile.shippingCity +
                    ", " +
                    currentClientProfile.shippingState +
                    " " +
                    currentClientProfile.shippingZip}
              </address>
            </div>
            <div className="col-md-6">
              <div className="col-12 client-profile-info-display-header">
                Company Email Addresses
                {!isReadOnly(decodedJWT) && (
                  <button
                    type="button"
                    className="btn p-0 shadow-none"
                    onClick={handleOpenClientEmailsEditModal}
                  >
                    <BsPencilSquare
                      className="mx-1 text-note"
                      style={{ marginTop: "-7px" }}
                    />
                  </button>
                )}
              </div>
              {/* {console.log(currentClientProfile.userEmailAddresses)} */}
              {/* {console.log(currentClientProfile.clientEmailAddresses)} */}
              <div className="col-md-7">
                <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                  {currentClientProfile?.clientEmailAddresses
                    ?.split(";")
                    .map((email, index) => {
                      return <li key={index + "-" + email}>{email.trim()}</li>;
                    })}
                </ul>
                {/* <EditableEmail
                        emailString={currentClientProfile.clientEmailAddresses}
                        returnNewEmailString={handleChangeClientEmails}
                        maxEmails={5}
                        maxEmailLength={500 / 5 - 2}
                        setEmailsValid={setClientEmailsValid}
                        resetStateNotif={resetClientInfoCount}
                      /> */}
              </div>
            </div>
          </div>
        </AccordionCard>

        <RestrictedContent allowedDivisionAccesses={[divisionAccesses.network]}>
          <AccordionCard
            eventKey="billingInformation"
            title="Billing Information"
            icon={BsJournalBookmarkFill}
          >
            <div className="row">
              <div className="col-md-4">
                <div className="col-12 client-profile-info-display-header">
                  Billing Type
                </div>
                <div className="col-12 pb-1">
                  {currentClientProfile.billingType}
                </div>
              </div>
              <div className="col-md-4">
                <div className="col-12 client-profile-info-display-header">
                  Billing Cycle
                </div>
                <div className="col-12 pb-1">
                  {currentClientProfile.billingCycle}
                </div>
              </div>
              <div className="col-md-4">
                <div className="col-12 client-profile-info-display-header">
                  Payment Terms
                </div>
                <div className="col-12 pb-1">
                  {currentClientProfile.paymentTerms}
                </div>
              </div>
              <div className="col-md-4">
                <div className="col-12 client-profile-info-display-header">
                  COD Fee
                </div>
                <div className="col-12 pb-1">
                  $
                  {currentClientProfile.codFee &&
                    currentClientProfile.codFee.toFixed(2)}{" "}
                  USD
                </div>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-4">
                <div className="col-12 client-profile-info-display-header">
                  Maximum Valuation Coverage
                </div>
                <div className="col-12 pb-1">
                  $
                  {currentClientProfile.maximumValuationAmount &&
                    currentClientProfile.maximumValuationAmount.toFixed(2)}{" "}
                  USD
                </div>
              </div>
              <div className="col-md-4">
                <div className="col-12 client-profile-info-display-header">
                  Minimum Valuation Coverage
                </div>
                <div className="col-12 pb-1">
                  $
                  {currentClientProfile.minimumValuationAmount &&
                    currentClientProfile.minimumValuationAmount.toFixed(2)}{" "}
                  USD
                </div>
              </div>
              <div className="col-md-4">
                <div className="col-12 client-profile-info-display-header">
                  Valuation Rate
                </div>
                <div className="col-12 pb-1">
                  {currentClientProfile.valuationRate &&
                    currentClientProfile.valuationRate.toFixed(2)}
                  %
                </div>
              </div>
            </div>
          </AccordionCard>
        </RestrictedContent>
        {/* Only diplay the dropship section if they have dropship clients */}
        <RestrictedContent allowedDivisionAccesses={[divisionAccesses.network]}>
          {currentClientProfile.dropShipInfos.length > 0 && (
            <AccordionCard
              eventKey={"dropshipInformation"}
              title="Dropship Information"
              icon={BsBoxSeam}
            >
              <div className="row">
                {currentClientProfile.dropShipInfos.map((dropShipClient) => {
                  return (
                    <address
                      key={dropShipClient.dropShipClientId}
                      className="col-md-6"
                      style={{
                        paddingLeft: "30px",
                        paddingRight: "30px",
                      }}
                    >
                      <div style={{ fontWeight: "600" }}>
                        {dropShipClient.dropShipClientName}
                      </div>
                      {dropShipClient.dropShipClientAddress}
                      <br />
                      {dropShipClient.dropShipClientCity +
                        ", " +
                        dropShipClient.dropShipClientState +
                        " " +
                        dropShipClient.dropShipClientZip}
                    </address>
                  );
                })}
              </div>
            </AccordionCard>
          )}
        </RestrictedContent>
        <RestrictedContent allowedDivisionAccesses={[divisionAccesses.network]}>
          <PDFDownload
            title="Useful Documents"
            subtitle="Procedures and Forms"
            eventKey="usefulDocumentsEventKey"
          >
            <option value={PDFs.NDLIFreightClaimsProcedures}>
              Claims Procedure
            </option>
            {/* <option value={}>Cod Procedure</option> */}
            <option value={PDFs.returns}>Returns Procedure</option>
            <option value={PDFs.natOpContactList}>
              National Operations Contact List
            </option>
            <option value={PDFs.codOptin}>Cod Opt-in Form</option>
          </PDFDownload>
        </RestrictedContent>
      </div>
    </>
  );
};
